import { getCookie } from "../../../api/utils/utils";
import { LoginProvider } from "../loginProvider/LoginProvider";
import { ILoginRequest } from "../type/Type";

export default class LoginService {
  static async login(payload: ILoginRequest) {
    const guestToken = getCookie("x-guest-token");
    const loginPayload = guestToken
      ? { ...payload, guest_token: guestToken }
      : payload;

    const res = await LoginProvider.postLogin(loginPayload);
    return res.data;
  }
  static async logout() {
    localStorage.removeItem("selectedBranch");
    localStorage.removeItem("name");
    localStorage.removeItem("deliveryOption");
    localStorage.removeItem("deliveryDetails");
    const res = await LoginProvider.postLogout();
    return res.data;
  }
}
